/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pass.vue?vue&type=template&id=2317c713&scoped=true"
import script from "./pass.vue?vue&type=script&lang=js"
export * from "./pass.vue?vue&type=script&lang=js"
import style0 from "./pass.vue?vue&type=style&index=0&id=2317c713&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2317c713",
  null
  
)

export default component.exports